import { defineComponent as _defineComponent } from 'vue'
import { StyleValue } from 'vue';

interface Props {
  items?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFeaturesBlocksMobile',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



const getItemBgStyle = (image: string): StyleValue | undefined =>
  image ? { backgroundImage: `url(${image})` } : undefined;

return { __sfc: true,getItemBgStyle }
}

})